/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CandidatesSearchAdditionalOptionsResponseDto } from '../models';
// @ts-ignore
import type { CandidatesSortByDto } from '../models';
// @ts-ignore
import type { ProcessCandidatesSearchResponseDto } from '../models';
// @ts-ignore
import type { SearchCandidatesRequestDto } from '../models';
// @ts-ignore
import type { SortDirectionDto } from '../models';
/**
 * ProcessCandidatesSearchRestApi - axios parameter creator
 */
export const ProcessCandidatesSearchRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Candidates Search Additional Options
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidatesSearchAdditionalOptions: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getCandidatesSearchAdditionalOptions', 'processId', processId)
            const localVarPath = `/api/v1/processes/{processId}/candidates/search/application-sources`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the list of candidates for a specific recruitment process, with optional filtering and sorting.
         * @summary Get candidates of a specific recruitment process
         * @param {string} processId 
         * @param {number} pageSize 
         * @param {number} page 
         * @param {boolean} newSearch 
         * @param {SearchCandidatesRequestDto} searchCandidatesRequestDto Search candidates
         * @param {SortDirectionDto} [sortOrder] 
         * @param {CandidatesSortByDto} [sortBy] 
         * @param {number} [searchId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processCandidatesSearch: async (processId: string, pageSize: number, page: number, newSearch: boolean, searchCandidatesRequestDto: SearchCandidatesRequestDto, sortOrder?: SortDirectionDto, sortBy?: CandidatesSortByDto, searchId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('processCandidatesSearch', 'processId', processId)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('processCandidatesSearch', 'pageSize', pageSize)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('processCandidatesSearch', 'page', page)
            // verify required parameter 'newSearch' is not null or undefined
            assertParamExists('processCandidatesSearch', 'newSearch', newSearch)
            // verify required parameter 'searchCandidatesRequestDto' is not null or undefined
            assertParamExists('processCandidatesSearch', 'searchCandidatesRequestDto', searchCandidatesRequestDto)
            const localVarPath = `/api/v1/processes/{processId}/candidates/search`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (newSearch !== undefined) {
                localVarQueryParameter['newSearch'] = newSearch;
            }

            if (searchId !== undefined) {
                localVarQueryParameter['searchId'] = searchId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchCandidatesRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessCandidatesSearchRestApi - functional programming interface
 */
export const ProcessCandidatesSearchRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProcessCandidatesSearchRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Candidates Search Additional Options
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCandidatesSearchAdditionalOptions(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CandidatesSearchAdditionalOptionsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCandidatesSearchAdditionalOptions(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessCandidatesSearchRestApi.getCandidatesSearchAdditionalOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the list of candidates for a specific recruitment process, with optional filtering and sorting.
         * @summary Get candidates of a specific recruitment process
         * @param {string} processId 
         * @param {number} pageSize 
         * @param {number} page 
         * @param {boolean} newSearch 
         * @param {SearchCandidatesRequestDto} searchCandidatesRequestDto Search candidates
         * @param {SortDirectionDto} [sortOrder] 
         * @param {CandidatesSortByDto} [sortBy] 
         * @param {number} [searchId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processCandidatesSearch(processId: string, pageSize: number, page: number, newSearch: boolean, searchCandidatesRequestDto: SearchCandidatesRequestDto, sortOrder?: SortDirectionDto, sortBy?: CandidatesSortByDto, searchId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessCandidatesSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processCandidatesSearch(processId, pageSize, page, newSearch, searchCandidatesRequestDto, sortOrder, sortBy, searchId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessCandidatesSearchRestApi.processCandidatesSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProcessCandidatesSearchRestApi - factory interface
 */
export const ProcessCandidatesSearchRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProcessCandidatesSearchRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Candidates Search Additional Options
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidatesSearchAdditionalOptions(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<CandidatesSearchAdditionalOptionsResponseDto> {
            return localVarFp.getCandidatesSearchAdditionalOptions(processId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the list of candidates for a specific recruitment process, with optional filtering and sorting.
         * @summary Get candidates of a specific recruitment process
         * @param {string} processId 
         * @param {number} pageSize 
         * @param {number} page 
         * @param {boolean} newSearch 
         * @param {SearchCandidatesRequestDto} searchCandidatesRequestDto Search candidates
         * @param {SortDirectionDto} [sortOrder] 
         * @param {CandidatesSortByDto} [sortBy] 
         * @param {number} [searchId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processCandidatesSearch(processId: string, pageSize: number, page: number, newSearch: boolean, searchCandidatesRequestDto: SearchCandidatesRequestDto, sortOrder?: SortDirectionDto, sortBy?: CandidatesSortByDto, searchId?: number, options?: RawAxiosRequestConfig): AxiosPromise<ProcessCandidatesSearchResponseDto> {
            return localVarFp.processCandidatesSearch(processId, pageSize, page, newSearch, searchCandidatesRequestDto, sortOrder, sortBy, searchId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProcessCandidatesSearchRestApi - interface
 */
export interface ProcessCandidatesSearchRestApiInterface {
    /**
     * 
     * @summary Get Candidates Search Additional Options
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCandidatesSearchAdditionalOptions(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<CandidatesSearchAdditionalOptionsResponseDto>;

    /**
     * Retrieve the list of candidates for a specific recruitment process, with optional filtering and sorting.
     * @summary Get candidates of a specific recruitment process
     * @param {string} processId 
     * @param {number} pageSize 
     * @param {number} page 
     * @param {boolean} newSearch 
     * @param {SearchCandidatesRequestDto} searchCandidatesRequestDto Search candidates
     * @param {SortDirectionDto} [sortOrder] 
     * @param {CandidatesSortByDto} [sortBy] 
     * @param {number} [searchId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    processCandidatesSearch(processId: string, pageSize: number, page: number, newSearch: boolean, searchCandidatesRequestDto: SearchCandidatesRequestDto, sortOrder?: SortDirectionDto, sortBy?: CandidatesSortByDto, searchId?: number, options?: RawAxiosRequestConfig): AxiosPromise<ProcessCandidatesSearchResponseDto>;

}

/**
 * ProcessCandidatesSearchRestApi - object-oriented interface
 */
export class ProcessCandidatesSearchRestApi extends BaseAPI implements ProcessCandidatesSearchRestApiInterface {
    /**
     * 
     * @summary Get Candidates Search Additional Options
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCandidatesSearchAdditionalOptions(processId: string, options?: RawAxiosRequestConfig) {
        return ProcessCandidatesSearchRestApiFp(this.configuration).getCandidatesSearchAdditionalOptions(processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the list of candidates for a specific recruitment process, with optional filtering and sorting.
     * @summary Get candidates of a specific recruitment process
     * @param {string} processId 
     * @param {number} pageSize 
     * @param {number} page 
     * @param {boolean} newSearch 
     * @param {SearchCandidatesRequestDto} searchCandidatesRequestDto Search candidates
     * @param {SortDirectionDto} [sortOrder] 
     * @param {CandidatesSortByDto} [sortBy] 
     * @param {number} [searchId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public processCandidatesSearch(processId: string, pageSize: number, page: number, newSearch: boolean, searchCandidatesRequestDto: SearchCandidatesRequestDto, sortOrder?: SortDirectionDto, sortBy?: CandidatesSortByDto, searchId?: number, options?: RawAxiosRequestConfig) {
        return ProcessCandidatesSearchRestApiFp(this.configuration).processCandidatesSearch(processId, pageSize, page, newSearch, searchCandidatesRequestDto, sortOrder, sortBy, searchId, options).then((request) => request(this.axios, this.basePath));
    }
}

